// FAQ entries shared by the FAQ guide page and the prerender.
module.exports = [
  {
    q: 'What is a daily poker tournament?',
    a: 'A daily (or “daily tournament”) is a recurring event on a casino or card-room calendar — often every day or the same weekday each week. Buy-ins are usually lower than festival majors, and structures are built for a single session rather than a multi-day series.'
  },
  {
    q: 'How do I find tournaments near me?',
    a: 'Search by room or city on the homepage, or open a state or city hub (Texas, California, Florida, Washington, Las Vegas, and others). Each hub lists rooms on file; open a room for contact details and any posted schedule.'
  },
  {
    q: 'Why doesn’t every room show a schedule?',
    a: 'Daily Tourneys only lists days, start times, and buy-ins when those fields are already in the database. If a room page has contact info but no schedule, the calendar has not been added yet — blank is better than guessing.'
  },
  {
    q: 'What does buy-in mean?',
    a: 'The buy-in is the cost to enter. Rooms often show a prize-pool amount plus a house fee (for example $100 + $20), or one combined total. Guaranteed (GTD) pools mean the house tops up if entries fall short of a posted minimum.'
  },
  {
    q: 'What is the difference between rebuy and re-entry?',
    a: 'A rebuy usually means buying more chips during an early period after dropping low or busting. Re-entry means buying a fresh entry (a new “bullet”) with a full starting stack, typically during late registration. Freezeouts allow neither — one bullet only.'
  },
  {
    q: 'How current are the schedules?',
    a: 'Schedules are compiled from public information the rooms post, such as their calendars, flyers, and websites, and they can fall out of date. Rooms change calendars for holidays and series, so always confirm start times and late-reg cutoffs with the poker room before you go. If something is wrong, email info@dailytourneys.com and we will fix it.'
  },
  {
    q: 'Can I filter by buy-in or day?',
    a: 'On a room’s tournament page you can filter by buy-in band, bounty/PLO tags, weekly vs series, and day. The homepage day browser also groups events that are already on file for a given weekday.'
  },
  {
    q: 'Is Daily Tourneys free?',
    a: 'Yes. Search, hubs, room pages, and guides are free to use. The site shows one sponsored banner for a third-party offer, and we may earn a commission if you sign up through it. It is separate from the tournament listings and does not affect which rooms or schedules appear.'
  },
  {
    q: 'How do I report a wrong schedule or a closed room?',
    a: 'Email info@dailytourneys.com with the room name and what changed. Corrections are checked and updated, and rooms can also ask us to update or remove their listing the same way.'
  }
];



// WEBPACK FOOTER //
// ./js/faq-items.js